import VideoComponent from "@components/Video"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body14Styles } from "@constants/typography"
import React from "react"
import styled from "styled-components"

export const Container = styled.div<{ $caption: boolean }>`
  padding: 0 20px 88px;

  @media ${breakpoints.tablet} {
    padding: 0 calc(1 / 12 * 100vw) 88px;
  }

  @media ${breakpoints.laptop} {
    padding: 0 calc(1 / 12 * 100vw) 163px;
    ${({ $caption }) => ($caption ? "padding-bottom: 145px;" : "")}
  }
`

export const VideoWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 40px);

  @media ${breakpoints.tablet} {
    width: calc(10 / 12 * 100vw);
    height: calc(10 / 12 * 100vw);
  }

  @media ${breakpoints.laptop} {
    width: calc(10 / 12 * 100vw);
    height: calc(10 / 12 * 100vw * 0.51);
  }

  video {
    &:focus {
      outline: none;
    }
  }
`

const CaptionWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  align-items: center;
`

const Caption = styled.div`
  width: calc(100% - 35px);
  font-family: "Avenir Roman";
  font-size: 15px;
  color: ${colors.black};
  line-height: 22px;
  opacity: 0.3;

  @media ${breakpoints.tablet} {
    ${body14Styles}
    color: ${colors.mediumGray};
    opacity: 1;
  }

  @media ${breakpoints.laptop} {
    ${body14Styles}
    color: ${colors.mediumGray};
    opacity: 1;
  }
`

const Dash = styled.div`
  width: 23px;
  height: 1px;
  margin-right: 12px;
  background-color: ${colors.mediumGray};
`

interface MediaVideoProps {
  autoplayVideo?: boolean
  blockId?: string
  caption?: string
  customVideoThumbnail?: string
  mobileVideoUrl?: string
  videoThumbnail?: string
  videoUrl: string
}

const MediaVideo: React.FC<MediaVideoProps> = ({
  autoplayVideo,
  blockId,
  caption,
  customVideoThumbnail,
  mobileVideoUrl,
  videoThumbnail,
  videoUrl,
}) =>
  videoUrl ? (
    <Container $caption={!!caption} id={blockId || undefined}>
      <VideoWrapper>
        <VideoComponent
          autoPlay={autoplayVideo}
          controls={true}
          loop={autoplayVideo}
          mobileSrc={mobileVideoUrl}
          muted={true}
          playsInline={true}
          poster={customVideoThumbnail ? customVideoThumbnail : videoThumbnail}
          preload="auto"
          src={videoUrl}
        />
      </VideoWrapper>
      {caption && (
        <CaptionWrapper>
          <Dash />
          <Caption>{caption}</Caption>
        </CaptionWrapper>
      )}
    </Container>
  ) : null

export default MediaVideo
